<template>
<div>
  <header
    :class="[
      'mainHeader w-full z-50 transition-all duration-300 mobile:!p-0',
      isScrolled
        ? 'fixed top-0 left-0 bg-white shadow-md'
        : 'absolute top-0 left-0 laptop:relative !bg-transparent'
    ]"
  >
    <nav
      class="navbar laptop:h-[70px] largeDesktop:h-24 mobile:h-auto navbar-expand-lg shadow-md mobile:px-2 largeDesktop:px-3 py-3 px-lg-2 z-10 mobile:rounded-br-[40px] tablet:rounded-br-[50px] bg-white"
    >
      <div class="container-fluid flex items-center">
        <!-- Logo -->
        <a
          @click="logoClicked()"
          :class="[
            'relative flex items-center rounded-full border-2 shadow-lg border-white p-0 transition-all duration-300 mr-5 cursor-pointer',
            isScrolled
              ? 'w-[50px] h-[50px] laptop:w-[60px] laptop:h-[60px] largeDesktop:w-[80px] largeDesktop:h-[80px]'
              : 'mobile:w-[60px] mobile:h-[60px] laptop:w-[90px] laptop:h-[90px] largeDesktop:w-[150px] largeDesktop:h-[150px] laptop:top-9 largeDesktop:top-11'
          ]"
        >
          <img
            src="../../../assets/images/happyHomeLogo.svg"
            alt="Logo"
            class="w-full h-full object-contain"
          />
        </a>
      </div>
    </nav>
  </header>
</div>

</template>

<script>
export default {
  data() {
    return {
      isScrolled: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    logoClicked(){
      this.$router.push('/dashboard');
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    },
  },
};
</script>